<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-60 md-medium-size-70 md-small-size-100" v-if="challenge">
          <md-card>
            <md-card-header class="md-card-header-blue">
              <h3 class="title">
                <img :src="challenge.titleImage" />
                {{challenge.title}}
              </h3>
              <small>{{ formatFromToDate(challenge.start, challenge.end) }}</small>
            </md-card-header>
            <md-card-content>
              <p>Bitte log dich vorher ein, damit du dich zu der Challenge anmelden kannst.</p>
              <p>Falls du noch keinen Benutzer hast, bitte registriere dich.</p>
              <!-- <p v-html="challenge.description" /> -->
            </md-card-content>
          </md-card>
    </div>
    <div class="md-layout-item md-size-33 md-medium-size-70 md-small-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-green">
              <h3 class="title">
                <img :src="logo" />
                Melde dich jetzt an!
              </h3>
            </md-card-header>

            <md-card-content>
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>E-Mail</label>
                  <md-input
                    v-model="email"
                    type="email"
                    autocomplete="email"
                  ></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="password"
                rules="required|min:5"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Kennwort</label>
                  <md-input
                    v-model="password"
                    type="password"
                    autocomplete="password"
                  ></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
              <router-link to="reset" style="float: left;"
                >Passwort vergessen</router-link
              >
            </md-card-content>

            <md-card-actions>
              <md-button type="submit" class="md-success">Anmelden</md-button>
            </md-card-actions>
          </md-card>
        </form>
        <p>Du hast noch keinen Account?</p>
        <router-link to="/Register"
          ><md-button class="md-primary"
            >Konto erstellen</md-button
          ></router-link
        >
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import Cookies from "js-cookie";
import datetime from "@/utils/datetime";


extend("email", email);
extend("required", required);
extend("min", min);

export default {
  mounted() {
    let red = this.$route.query.redirect || '';
    // var found = red.match(/\/Challenges\/([^\/?]*)[?&]+((join-)*code|voucher)=(.*)/i);
    var found = red.match(/\/Challenges\/([^\/?]*).*/i);
    if (found && found.length > 1 && found[1]) {
      const challengeId = found[1];
      this.$store
        .dispatch("queryAPI", {url: "/rest/challenge/public/" + challengeId})
        .then(data => (this.challenge = data));
    }
  },
  data() {
    return {
      email: "",
      password: "",
      challenge: undefined
    };
  },
  props: {
    logo: {
      type: String,
      default: "/img/sports4me.svg"
    }
  },
  methods: {
    ...datetime,
    submit() {
      let email = this.email;
      let password = this.password;
      this.$store
        .dispatch("login", { email, password })
        .then(() => {
          this.$router.push("/");

          // Notify the login
          // this.$notify({
          //   timeout: 5000,
          //   message: "Du bist jetzt angemeldet!",
          //   icon: "add_alert",
          //   horizontalAlign: "right",
          //   verticalAlign: "top",
          //   type: "success"
          // });
        })
        .catch(err => {
          // console.log("error login", err);
          if (err.response && err.response.status === 401) {
            this.$notify({
              timeout: 5000,
              message:
                "Deine Daten sind leider nicht korrekt! Bitte versuche es nochmals.",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
            this.email = "";
            this.password = "";
          } else if (err.message) {
            this.$notify({
              timeout: 5000,
              message:
                "Ein unerwarteter Fehler ist aufgetretten:" + err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
